import Navbar from './components/Navbar';
import Hero from './components/Hero';
import WindowRepairInfo from './components/WindowRepairInfo';
import ValueProposition from './components/ValueProposition';
import QuickActions from './components/QuickActions';
import Services from './components/Services';
import LeadsQualifies from './components/LeadsQualifies';
import OffreSpeciale from './components/OffreSpeciale';
import OffreGratuite from './components/OffreGratuite';
import WhyBuyLeads from './components/WhyBuyLeads';
import StatsProof from './components/StatsProof';
import ROICalculator from './components/ROICalculator';
import Testimonials from './components/Testimonials';
import RecruitmentSection from './components/RecruitmentSection';
import TransitionBlock from './components/TransitionBlock';
import WhatsAppAlerts from './components/WhatsAppAlerts';
import Paiement from './components/Paiement';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* 1. ACCROCHE - Première impression */}
      <Hero />
      
      {/* 2. CONTEXTE - Pourquoi c'est important */}
      <WindowRepairInfo />
      
      {/* 3. SOLUTION - Ce qu'on propose */}
      <ValueProposition />
      
      {/* 4. PREUVE SOCIALE - Chiffres qui rassurent */}
      <StatsProof />
      
      {/* 5. TARIFICATION PAR ZONES */}
      <Services />
      
      {/* 6. EXEMPLES CONCRETS - Voir les leads */}
      <LeadsQualifies />
      
      {/* 7. OFFRE GRATUITE - Tester sans risque */}
      <OffreGratuite />
      
      {/* 8. OFFRE CHOC - Prix attractif */}
      <OffreSpeciale />
      
      {/* 9. BÉNÉFICES - Pourquoi acheter */}
      <WhyBuyLeads />
      
      {/* 10. CALCULATEUR - Visualiser le ROI */}
      <ROICalculator />
      
      {/* 11. TÉMOIGNAGES - Preuve sociale */}
      <Testimonials />
      
      {/* 12. TRANSITION - Bloc de respiration */}
      <TransitionBlock />
      
      {/* 13. WHATSAPP - Comment recevoir */}
      <WhatsAppAlerts />
      
      {/* 14. ACTIONS RAPIDES - Faciliter le passage à l'action */}
      <QuickActions />
      
      {/* 15. PAIEMENT - Rassurer sur le processus */}
      <Paiement />
      
      {/* 16. RECRUTEMENT - Fusionnés */}
      <RecruitmentSection />
      
      {/* 17. CONTACT - Formulaire de contact */}
      <Contact />
      
      {/* 18. FAQ - Lever les dernières objections */}
      <FAQ />
      
      {/* 19. FOOTER - Informations légales */}
      <Footer />
    </div>
  );
}